/*
 * 任务管理
 * */
export const TASKGETPAGE = 'TASKGETPAGE'
export const TASKADD = 'TASKADD'
export const TASKGETGOODS = 'TASKGETGOODS'
export const TASKUPDATE = 'TASKUPDATE'
export const TASKGETTASK = 'TASKGETTASK'
export const GETTASKDETAILS = 'GETTASKDETAILS'
export const UPDATESTATUSS = 'UPDATESTATUSS'
export const COMPLETETASK = 'COMPLETETASK'
export const SUPPLIERGETLIST = 'SUPPLIERGETLIST'
export const TASKGETGOODSS = 'TASKGETGOODSS'
export const TASKGETGOODTSS = 'TASKGETGOODTSS'
export const GETCHIDES = 'GETCHIDES'
export const SUPPLIERGETLISTDATA = 'SUPPLIERGETLISTDATA'
export const SETTAKEORDERSBTNDIS = 'SETTAKEORDERSBTNDIS' // 设置是否禁用接单按钮
export const SETCANCELTASKBTNDIS = 'SETCANCELTASKBTNDIS' // 设置是否禁用取消任务按钮
export const SETSAVEBTNDIS = 'SETSAVEBTNDIS' // 设置是否禁用确认完成模板配置保存按钮
export const SETCONFIRMBTNDIS = 'SETCONFIRMBTNDIS' // 设置是否禁用确认完成按钮
export const GETGOODSBATCH = 'GETGOODSBATCH' // 设置是否禁用确认完成按钮
export const UPDATETASKURLS = 'UPDATETASKURLS' // 设置是否禁用确认完成按钮
export const IMPORTASK = 'IMPORTASK'
export const GETOUTBOUNDTASKMERGELIST = 'GETOUTBOUNDTASKMERGELIST'
export const GETWAREHOUSEARERSSELECT = 'GETWAREHOUSEARERSSELECT'
export const GETWAREHOUSEADDESSSELECT = 'GETWAREHOUSEADDESSSELECT'
export const GETOUTBOUNDTASKMERGEINFO = 'GETOUTBOUNDTASKMERGEINFO'
export const ADDOUTBOUNDTASKMERGE = 'ADDOUTBOUNDTASKMERGE'
export const FINISHWAREHOUSETASKMERGE = 'FINISHWAREHOUSETASKMERGE'

export const SAVETASKPRINTBILLINTODATA = 'SAVETASKPRINTBILLINTODATA' // 保存打印入库单的商品数据
export const SAVETASKPRINTBILLOUTDATA = 'SAVETASKPRINTBILLOUTDATA' // 保存打印出库单的商品数据
export const SAVETASKPRINTBILLPICKDATA = 'SAVETASKPRINTBILLPICKDATA' // 保存打印拣货单的商品数据
export const SAVETASKPRINTBILLPUTAWAYDATA = 'SAVETASKPRINTBILLPUTAWAYDATA' // 保存打印上架单的商品数据

/*
 * 贴标任务
 * */
export const TASKGETPSUPPLIERTASKLABLE = 'TASKGETPSUPPLIERTASKLABLE'
export const SUPPLIERTASKLABLEADD = 'SUPPLIERTASKLABLEADD'
export const SUPPLIERTASKLABLECANCEL = 'SUPPLIERTASKLABLECANCEL'

/*
 * 包膜任务
 * */
export const GETENVELOPEPAGE = 'GETENVELOPEPAGE'
export const ADDENVELOPE = 'ADDENVELOPE'
export const GETENVELOPE = 'GETENVELOPE'

export const GETALLPOINT = 'GETALLPOINT'
export const COUNTPLATENUM = 'COUNTPLATENUM'
export const GETTEMPLATEDATA = 'GETTEMPLATEDATA'

export const CANCELPRINTTEMP = 'CANCELPRINTTEMP' // 关闭打印面单按钮
export const CHANGEGOODSLISTNUM = 'CHANGEGOODSLISTNUM' // 进行中，点击打印面单，保存页面数据

/*
 * 出入库明细
 * */

export const GETALLTASKGOOD = 'GETALLTASKGOOD' // 获取列表
export const DOWNLOADTASKGOOD = 'DOWNLOADTASKGOOD' // 导入
export const QUERYGOODSPRODUCTIONTIME = 'QUERYGOODSPRODUCTIONTIME' // 查看生产日期
export const GETTASKSIGNREGISTERLIST = 'GETTASKSIGNREGISTERLIST' // 获取签收数量登记/签收信息列表
export const SUBMITTASKSIGNREGISTER = 'SUBMITTASKSIGNREGISTER' // 保存签收数量
export const GETTASKLOGLIST = 'GETTASKLOGLIST' // 操作记录
export const GETTENANTDROP = 'GETTENANTDROP'// 商户名称下拉
export const GETBYTENANT = 'GETBYTENANT'// 仓库名称下拉


export const getGoods = 'getGoods'// 仓库名称下拉
export const getGoodsBatch = 'getGoodsBatch'// 仓库名称下拉
export const editTask = 'editTask'// 仓库名称下拉
export const getStatus6TaskDetails = 'getStatus6TaskDetails'// 仓库名称下拉
export const finishForPicking = 'finishForPicking'// 仓库名称下拉

export const download = 'download'// 下载出库商品批量导入模板activateDraft
export const activateDraft = 'activateDraft'// 下载出库商品批量导入模板activateDraft
export const supplementGoodsBatch = 'supplementGoodsBatch'// 下载出库商品批量导入模板activateDraft

export const saveBatchProduction = 'saveBatchProduction'



// WEBPACK FOOTER //
// ./src/store/assignmentManage/types.js